package org.hs_soft.runmynesto.di.home

import org.hs_soft.runmynesto.domain.usecase.home.FetchIdTokenUseCase
import org.hs_soft.runmynesto.domain.usecase.home.GetLanguageUseCase
import org.hs_soft.runmynesto.domain.usecase.home.GetSavedCheckOutUseCase
import org.hs_soft.runmynesto.domain.usecase.home.GetSavedShopListUseCase
import org.hs_soft.runmynesto.domain.usecase.home.GlobalSearchUseCase
import org.hs_soft.runmynesto.domain.usecase.home.HSSoftAppsUseCase
import org.hs_soft.runmynesto.domain.usecase.home.SaveCheckOutUseCase
import org.hs_soft.runmynesto.domain.usecase.home.SetNewCustomerUseCase
import org.hs_soft.runmynesto.domain.usecase.home.ShopListUseCase
import org.hs_soft.runmynesto.domain.usecase.home.SignOutUseCase
import org.hs_soft.runmynesto.domain.usecase.home.UserProfileDataUseCase
import org.hs_soft.runmynesto.domain.usecase.options.virtual_card.GetVirtualCardInfoUseCase
import org.hs_soft.runmynesto.domain.usecase.product.DeleteCacheUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.GetDataAssistantAnswerUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.GetDataAssistantMessageHistoryUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.SaveDataAssistantFavoriteMessagesUseCase
import org.koin.dsl.module


val homeUseCaseModule= module {

    single {
        GlobalSearchUseCase(get())
    }
    single {
        SetNewCustomerUseCase(get())
    }
    single {
        FetchIdTokenUseCase(get())
    }
    single {
        GetSavedCheckOutUseCase(get())
    }
    single {
        SaveCheckOutUseCase(get())
    }
    single {
        SignOutUseCase(get())
    }
    single {
        UserProfileDataUseCase(get())
    }
    single {
        HSSoftAppsUseCase(get())
    }
    single {
        ShopListUseCase(get())
    }
    single {
        GetSavedShopListUseCase(get())
    }
    single {
        DeleteCacheUseCase(get())
    }

    single {
        GetLanguageUseCase(get())
    }

    single {
        GetDataAssistantAnswerUseCase(get())
    }

    single {
        GetDataAssistantMessageHistoryUseCase(get())
    }

    single {
        SaveDataAssistantFavoriteMessagesUseCase(get())
    }

    single {
        GetVirtualCardInfoUseCase(get())
    }


}